
    import {
        Component,
        EventEmitter,
        Input,
        AfterViewInit,
        OnInit,
        Output,
        ViewChild,
        ViewEncapsulation
    } from "@angular/core";

import { EMPTY, Subscription } from 'rxjs';
import { ConfirmationService, SelectItem } from "primeng/api";
import { RacingService } from '../../../rest/racing.service';
import { ExcelMappingService } from 'app/modules/task/Logistics/services/excel-mapping.service';
import { Rest } from 'app/rest/rest_client';
import { Rest_logistics } from 'app/modules/task/Logistics/services/rest_client_logistics';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { ZoneGroupFormComponent } from 'app/components/zones/zone-group-form/zone-group-form.component';
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';
import { I18nService } from "../../../services/i18n/i18n.service";
import { ZonegroupService } from "../../../rest/zonegroup.service";
import { NoticegroupService } from "../../../rest/noticegroup.service";
import { EntityFormComponent } from "../../entity-form/entity-form.component";
import { Auxiliar } from "../../../model/Auxiliar";
import { RestExt } from "../../../services/rest-client-extension";

@Component({
    selector: 'app-racing-poiszones',
    templateUrl: './racing-poiszones.component.html',
    styleUrls: ['./racing-poiszones.component.css'],
    providers: [ZonegroupService,NoticegroupService,ConfirmationService,ExcelMappingService],
    encapsulation: ViewEncapsulation.None,
})
// 
// extends EntityFormComponent<Rest.Racing> 
export class RacingPoisZonesComponent implements AfterViewInit {
    @Input() eventId: number;
    @Input() eventName: string;
    @Input() poisconvert : Rest.POIRacing[];
    @Input() startDate:Date;
    @Input() endDate:Date;
    @Output() closeDialog = new EventEmitter<any>();
    isDialogVisible: boolean = false;
    isEditingDisabled: boolean = false;
    isSaveGranted: boolean = false;
    errorMessages: string[] = [];
    severeError: boolean = false;
    formTitle: string = 'Convert POIS to Zones';
    zoneGroupLabel: string ='Zone Group';
    nameLabel: string = 'Name';
    eventsLabel: string = 'Events';
    saveLabel: string = 'Save';
    enterLabel: string = 'Enter';
    leaveLabel: string = 'Leave';
    radius: string = 'Radius';
    nameGroupZone:String="";
    eventOnEnter:boolean=false;
    eventOnLeave:boolean=false;
    radiusValue:number=0;
    availableZoneGroups: SelectItem[];
    @ViewChild('ZoneGroupFormComponent') zoneGroupForm: ZoneGroupFormComponent;
   // zoneGroupService: ZonegroupService;
    noticeGroupCreated: Rest.NoticeGroup;
    selectedPreconfig2: any;
    zonePlaceholder: string;
    zoneGroups: Rest.ZoneGroup[];
    selectedZoneGroup: Rest.ZoneGroup;
    zoneGroupCreated: Rest.ZoneGroup;
    zoneRequestContext:Rest.PoisZones;
	poisgenerate: Rest.POIRacing[] = [];
	generateSpinner: boolean = false;
    constructor(
        private datePipe: DatePipe,
        protected authenticationService: AuthenticationService,
        protected notificationsService: NotificationsService,
        protected translate: TranslateService,
        protected racingService: RacingService,
        protected i18n: I18nService,
        protected zonegroupService: ZonegroupService,
        private noticegroupService: NoticegroupService,
        private confirmationService: ConfirmationService
    ) {
        // super(racingService, notificationsService, i18n, authenticationService);
      //  this.zoneGroupService = zonegroupService;
    }

    ngAfterViewInit(): void {
        //console.log('[ORDERS-FROM-EXCEL] ngOnInit ***');
        let that = this;
          this.zoneGroupForm.return
             .subscribe((entity: Rest.ZoneGroup) => {
                 if (entity !== undefined && entity.id > 0) {
                   that.confirmationService.confirm({
                          message: that.i18n._(
                               "Do you want to be notified about the events of the Zones in the Zone Group created?"
                        ),
                         accept: () => {
                               let usersList = [];
                             let tagEventsList = [];
                              usersList.push(entity.owner);
                              tagEventsList.push("ZONE_ENTER_zgId" + entity.id);
                             tagEventsList.push("ZONE_LEAVE_zgId" + entity.id);
    
                          let newNoticeGroup: Rest.NoticeGroup = {
                                id: null,
                                 enabled: true,
                                  owner: entity.owner,
                                  name: "Notice Group " + entity.name,
                                 description: "Notice_Group_zgId" + entity.id,
                                  notifyBySMS: true,
                                 notifyByApp: false,
                                 notifyByEmail: true,
                                   notifyByWeb: true,
                                  visibleUsers: usersList,
                                 visibleFleets: entity.fleets,
                                   visibleVehiclesGroups: entity.vehiclesGroups,
                                 visibleVehicles: entity.vehicles,
                                   tag_events: tagEventsList,
                                   noticeChannelsStr: "",
                                   visibleCustomers:[],
                                  notificationText: "",
                                  sender:"",
                                  startDate:that.startDate,
                                  endDate:that.endDate 
                              };

                             that.noticegroupService
                                 .createNoticeEvents(newNoticeGroup)
                                   .then(
                                      function (ret) {
                                         that.notificationsService.add(
                                             Severity.success,
                                               that.i18n._(":)"),
                                             that.i18n._("Notice Group Created")
                                           );
                                           that.noticeGroupCreated = ret;
                                       },
                                       (err) => {
                                          console.log(err);
                                          this.notificationsService.add(
                                            Severity.warn,
                                            this.i18n._(":("),
                                            this.translate.instant("administration.customers.notification.ErrorNotification")
                                           );
                               
                                         //  that.handleError(err, that);
                                      }
                                   )
                                 .catch((e) => {
                                    this.notificationsService.add(
                                        Severity.warn,
                                        this.i18n._(":("),
                                        this.translate.instant("administration.customers.notification.ErrorNotification")
                                       );
                           
                                       //this.handleError(e, that);
                                   });
                          }
                       });

                       that.zoneGroups.push(Auxiliar.toEntitySelectItem(entity).value); //-- RAQUEL MIRAR PORQUE TENGO QUE COGER EL VALUE Y LUEGO NO REFRESCA EL LISTADO PRINCIPAL--//
                       const newOption = Auxiliar.toEntitySelectItem(entity);
                       that.availableZoneGroups.push(newOption);
                       that.selectedZoneGroup = entity;
                 //       that.selectedPreconfig2 = entity;
                        that.selectedPreconfig2=newOption;
                       that.notificationsService.add(
                           Severity.success,
                           that.i18n._(":)"),
                           that.i18n._("Zone Group Created")
                       );
                       that.zoneGroupCreated = entity;
                  }
             });
    }

    async initpoiszones() {
        this.generateSpinner = false;
        let that = this;
        let allZG = (
            await that.zonegroupService.getPage(RestExt.allRecordsRequest())
        ).entities;
        this.zoneGroups = allZG.filter((zg) => zg.enabled );
        this.availableZoneGroups = this.zoneGroups.map(item => ({
            value: item.id,
            label: item.name
        }));

       this.translateLabels();
       this.selectedPreconfig2=null;
       if (this.zoneGroups.length==1){
        this.selectedPreconfig2 = this.availableZoneGroups[0];
       }
    
      
    
     }


    zoneGroupChanged() {
        //esto lo he puesto porque al crear un grupo de zona, en this.selectedPreconfig2.value había el objeto completo de grupozona.
        if (this.selectedPreconfig2.value?.id)this.selectedPreconfig2.value = this.selectedPreconfig2.value.id;  
    
    }

    createZoneGroup(){
        this.zoneGroupForm.create();
    }

    closeForm(event) {
      //close form group Devemos recoger el valor
    //  this.zoneGroups = [event, ...this.zoneGroups];
    //  this.availableZoneGroups = this.zoneGroups.map(item => ({
    //     value: item.id,
    //     label: item.name
    //     }));
    //     this.selectedPreconfig2 = event;
    }
    private translateLabels() {
        this.formTitle= this.translate.instant('events.pois.convertPoisZone');
        this.zoneGroupLabel = this.translate.instant('zones.zone-group.zone-group-data');
      //  this.fleetsLabel = this.translate.instant('zones.zone-group.fleets');
        this.nameLabel = this.translate.instant('zones.zone-group.name');
        this.eventsLabel = this.translate.instant('zones.zone-form.events');
        this.saveLabel = this.translate.instant('zones.zone-form.save');
        this.enterLabel = this.translate.instant('zones.zone-form.enter');
        this.leaveLabel = this.translate.instant('zones.zone-form.leave');
        this.radius= this.translate.instant('zones.zone-form.radius');
        this.zonePlaceholder = this.translate.instant('zones.zone-form.select-zone');
    }

    public showDialog(): void {
        this.selectedZoneGroup = null;
        this.nameGroupZone= this.eventName;
        this.initpoiszones();
        this.isDialogVisible = true;
    }

    validatezones():boolean{
       this.validateQuantity();
        if (this.selectedPreconfig2 == null) 
        {
            this.notificationsService.add(
               Severity.warn,
               this.i18n._(":("),
               this.translate.instant("zones.zone-form.select-zone")
              );
  
            return false;
        }
        if ((this.radiusValue > 10000) ||(this.radiusValue < 0) )
        {
            this.notificationsService.add(
                Severity.warn,
                this.i18n._(":("),
                this.translate.instant("zones.zone-form.valueradiusko")
               );
   
             return false;
        }
        return true;
    }

    savePoiZone(){
        console.log("savePoi()");
        if (this.validatezones()) 
        {
            if (this.selectedPreconfig2.value?.id)this.selectedPreconfig2.value = this.selectedPreconfig2.value.id;  
            this.generateSpinner = true;
            this.zoneRequestContext = {  
                eventOnEnter: this.eventOnEnter,
                eventOnLeave: this.eventOnLeave ,
                radius: this.radiusValue, 
                poiEvents: this.poisconvert,
                zoneGroupId: this.selectedPreconfig2.value
            };	
            this.poisgenerate = [];
             const promise = new Promise<void>((resolve, reject) => {
                 const that = this;
                  this.racingService
                      .Poi_generateZonesPois(this.zoneRequestContext, this.eventId)
                      .then(
                         function (response) {
                             that.notificationsService.add(
                                  Severity.success,
                                  ':)',
                                  that.translate.instant('general.successMsg')
                             );
                             that.generateSpinner = false;
                             that.poisgenerate = response;
                             that.closeDialog.emit(that.poisgenerate);  
                             that.isDialogVisible = false;    
                        },
                          /* failure */
                         function (error) {
                            console.log('The request failed: ' + error);
                            that.notificationsService.add(
                                 Severity.error,
                                  'ERROR',
                                  that.translate.instant('events.pois.errorcreatezones')
                              );
                             resolve();
                             this.generateSpinner = false;
                         }
                      )
                      .catch(function (reason) {
                          console.log('Catched: ' + reason);
                          resolve();
                          this.generateSpinner = false;
                      });
              });
        }
    }

    validateQuantity(){
        if (!this.radiusValue) {
            this.radiusValue = 0;  
            return;
        }
      
       // Convertir el valor a un número entero positivo (descarta decimales o caracteres no numéricos)
        if(this.radiusValue > 10000) this.radiusValue = 10000;
        if (this.radiusValue < 0) this.radiusValue = 0;
      
        // Si el valor es NaN o menor que 0, restablece a 0; de lo contrario, asigna el valor parseado
        this.radiusValue = isNaN(this.radiusValue) || this.radiusValue < 0 ? 0 : this.radiusValue;
      }
    
}
